<template lang="html">
    <div>
        <div class="container container-small mt-0 pb-4">
            <Heading class="py-4" :title="$t('add_car_title')" :routeName="'my-cars'"></Heading>
            <div class="row">
                <div class="col-12 col-md-5">
                    <div class="form-group">
                        <label>{{ $t('label_license_plate') }}</label>
                        <span v-if="errorMsgs._plateNo" class="invalid-feedback">
                            {{errorMsgs._plateNo}}
                        </span>
                        <input type="text" class="form-control" v-model="car._plateNo" v-bind:class="{'has-error': errorMsgs._plateNo}">
                    </div>
                </div>
                <div class="col-12 col-md-7">
                    <div class="form-group">
                        <label>{{ $t('label_chasis_number') }}</label>
                        <span v-if="errorMsgs._chasisNo" class="invalid-feedback">
                            {{errorMsgs._chasisNo}}
                        </span>
                        <input type="text" class="form-control" v-model="car._chasisNo" v-bind:class="{'has-error' : errorMsgs._chasisNo}">
                    </div>
                </div>
            </div>
            <div class="form-group" v-if="countries">
                <label for="taraInmatriculare">{{ $t('label_registration_country') }}</label>
                <select class="form-control" id="taraInmatriculare" v-model="car._country" >
                    <option v-for="c in countries" :value="c.id">{{c.country}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="motivCategorie">{{ $t('label_motif') }}</label>
                <input type="text" class="form-control" id="motivCategorie" v-model="car._reason">
            </div>
            <div class="form-group">
                <label>{{ $t('label_choose_category') }} <b>{{ $tc('vignetteWord', 1) }}</b>:</label>
                <div class="list-group">
                    <span v-if="errorMsgs._category" class="invalid-feedback">
                        <b>{{errorMsgs._category}}</b>
                    </span>
                    <div class="list-group-item list-group-item-action" v-for="(item, key) in categoriesVignette" v-bind:key="key" v-bind:class="[{'active' : car._category == item.id}]" v-on:click="setCategoryVignette(item.id)">
                        <p>{{item.title}}</p>
                        <span v-html="item.desc"></span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>{{ $t('label_choose_category') }} <b>{{ $tc('tollWord', 1) }}</b>:</label>
                <div class="list-group">
                    <span v-if="errorMsgs._category_TPF" class="invalid-feedback">
                        <b>{{errorMsgs._category_TPF}}</b>
                    </span>
                    <div class="list-group-item list-group-item-action" v-for="(item, key) in categoriesToll" v-bind:key="key" v-bind:class="[{'active' : car._category_TPF == item.id}]" v-on:click="setCategoryToll(item.id)">
                        <p>{{item.title}}</p>
                        <span v-html="item.desc"></span>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button @click="addCar()" class="btn btn-purple w-100">{{ $t('btn_add_car') }}</button>
            </div>
        </div>
    </div>

</template>

<script>

import Heading from './../snippets/Heading.vue'
import { mapActions } from 'vuex'

export default {
    data: function() {
        return {
            countries: null,
            categoriesToll: null,
            categoriesVignette: null,
            car: {
                _plateNo: '',
                _chasisNo: '',
                _country: 1,
                _reason: '',
                _category: '',
                _category_TPF: '',
            },

            errorMsgs: {
                _plateNo: '',
                _chasisNo: '',
                _category: '',
                _category_TPF: '',
            },

            loading: false
        }
    },
    components: {
        Heading
    },
    mounted() {
        this.init();
    },
    watch: {
        'car._plateNo': function(newVal, oldVal) {
            this.car._plateNo = newVal.toUpperCase();
        },
    },
    methods: {
        ...mapActions('vehicles', [
            'addVehicle'
        ]),
        async init() {
            this.getCountries();
            await this.getCategoriesToll();
            await this.getCategoriesVignette();
        },

        getCountries() {
            if(this.$store.getters['countries/getCountries'] != null) {
                this.countries = this.$store.getters['countries/getCountries'];
            }
            else {
                this.$store.dispatch('countries/getCountries').then(response => {
                    this.countries = response.data.countries;
                }, error => {
                    console.log(error);
                });
            }
        },

        async getCategoriesToll() {
            if(this.$store.getters['categories/getCategoriesToll'] != null) {
                this.categoriesToll = this.$store.getters['categories/getCategoriesToll'];
            }
            else {
                await this.$store.dispatch('categories/getCategoriesToll').then(response => {
                    this.categoriesToll = response.data.categories;
                }, error => {
                    console.log(error);
                });
            }
        },

        async getCategoriesVignette() {
            if(this.$store.getters['categories/getCategoriesVignette'] != null) {
                this.categoriesVignette = this.$store.getters['categories/getCategoriesVignette'];
            }
            else {
                await this.$store.dispatch('categories/getCategoriesVignette').then(response => {
                    this.categoriesVignette = response.data.categories;
                }, error => {
                    console.log(error);
                });
            }
        },

        setCategoryVignette(id) {
            this.car._category = id;
        },

        setCategoryToll(id) {
            this.car._category_TPF = id;
        },

        validate()
        {
            this.clearErrors(this.errorMsgs);
            var ok = true;

            var mandatoryText = this.$t('mandatory');

            if(!this.car._plateNo) {
                ok = false;
                this.errorMsgs._plateNo = mandatoryText;
            }

            let plateNoOk = this.validatePlateNo(this.car._plateNo, this.car._country);

            if(!plateNoOk) {
                ok = false;
                this.errorMsgs._plateNo = this.$t('invalid_plate_number_message');
            }

            if(!this.car._chasisNo) {

                ok = false;
                this.errorMsgs._chasisNo = mandatoryText;
            }
            else if(!this.validateChasisNo(this.car._chasisNo)) {

                ok = false;
                this.errorMsgs._chasisNo = this.$t('invalid');
            }

            if(!this.car._category) {
                ok = false;
                this.errorMsgs._category = mandatoryText;
            }

            if(!this.car._category_TPF) {
                ok = false;
                this.errorMsgs._category_TPF = mandatoryText;
            }

            return ok;
        },

        async addCar()
        {
            if(!this.validate()) return false;

            this.loading = true;

            try {
                let response = await this.addVehicle(this.car);
                this.$router.push({ name: 'my-cars' });
            } catch (error) {
                this.loading = false;

                if(error.response) {
                    this.$dialog.alert({
                        'message': error.response.data.errors.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        }
    }
}

</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #272D37;

.logout {
    display: inline-block;
    float: right;
    .fa-sign-out-alt{
        font-size: 24px;
    }
    a:link {
        color: white;
        text-decoration: none;
    }
    a:visited {
        color: white;
        text-decoration: none;
    }
    a:hover {
        color: white;
        text-decoration: none;
    }
    a:active {
        color: white;
        text-decoration: none;
    }
}

.list-group {
    .active {
        border-color: $green;
        border-left-width: 10px;
        background: inherit;
        color: inherit;
    }
    .list-group-item {
        padding: 6px 12px;
        cursor: pointer;
        p {
            margin: 0px;

        }
        span {
            color: $lightgrey;
            font-size: 12px;
        }
    }
}

.form-group {
    margin-bottom: 1rem;
}

</style>
